import { ColDef } from "ag-grid-community";
import { CellValueRenderer } from "page/Automatensuche/components/DataGrid/DataGrid";

const AbrufPanelColumnDefs: Array<ColDef> = [
  {
    field: "kommTyp",
    headerName: "Auftragstyp",
    maxWidth: 120,
  },
  {
    field: "statusCellNode",
    headerName: "Status",
    maxWidth: 100,
    cellRenderer: CellValueRenderer,
  },
  {
    field: "created",
    headerName: "gestartet",
    maxWidth: 200,
  },
  {
    field: "ended",
    headerName: "beendet",
    maxWidth: 200,
  },
  {
    field: "ftpReplyMessage",
    headerName: "FTP-Meldung",
    maxWidth: 280,
  },
  {
    field: "ftpFilename",
    headerName: "Dateiname",
    maxWidth: 180,
  },
  {
    field: "ftpFileDateTime",
    headerName: "Dateidatum",
    maxWidth: 200,
  },
  {
    field: "ftpFileSize",
    headerName: "Größe",
    maxWidth: 140,
  },
];

export default AbrufPanelColumnDefs;
